import React from 'react';
import { useAppDispatch } from 'src/store/hooks';
import { handleModalRegister } from 'src/store/actions/modal';
import LoginForm from './LoginForm';
import AuthImage from '../AuthImage';
import Container from 'src/components/reusable/Container';

interface LoginProps {}

const Login: React.FC<LoginProps> = ({}) => {
  const dispatch = useAppDispatch();

  const handleOpenRegister = () => {
    dispatch(handleModalRegister(true));
  };

  return (
    <Container>
      <div className="relative block lg:flex min-h-full gap-x-16 justify-center items-center">
        <div className="basis-2/5 z-50">
          <LoginForm openRegister={handleOpenRegister} />
        </div>
        <div className="basis-3/5 hidden lg:flex">
          <AuthImage
            buttonText="Create account"
            handleClick={handleOpenRegister}
          />
        </div>
      </div>
    </Container>
  );
};

export default Login;
